import React from 'react';
import cn from 'classnames';

import { getImage } from '@utils';
import defaultImage from '@images/MultiNavDefault.png';
import styles from './MultiVehicleNav.module.scss';

const VehicleImage = ({ shortcode, scale = 1.5 }) => {
  const image = shortcode
    ? getImage({
        shortcode,
        camera: 'Angle_EXT_9_0009',
        width: 360 * scale,
        height: 270 * scale,
        scene: 'alpha',
      })
    : defaultImage;
  return (
    <div
      className={cn(styles.VehicleImage)}
      style={{ backgroundImage: `url(${image})` }}
    ></div>
  );
};
export default VehicleImage;
